<br>
    <div class="page-wrapper bg-gra-03 p-t-45 p-b-50">
        <div  class="wrapper wrapper--w790">
            <div class="card card-5">
                <div class="card-heading">
                    <h2 class="title">Se connecter
                    </h2>
                </div>
                
                
                <div class="card-body">
                    
                    <form   [formGroup]="addOxygenForm" (ngSubmit)="onSubmit()" >
						<div style="text-align: center;" *ngIf="errormsg" class="alert alert-danger" role="alert">
							{{errormsg}}
					</div><br>
                        <div class="form-row">
                          <div class="name">  <i class="fa fa-envelope" aria-hidden="true"></i> Email 
                          </div>
                          <div class="value">
                              <div class="input-group">
                                  <input formControlName="email"  class="input--style-5" type="email" name="email">
                              </div>
                            <!--   <div *ngIf="addOxygenForm.controls['telnum'].invalid && (addOxygenForm.controls['telnum'].dirty || addOxygenForm.controls['telnum'].touched)" class="alert alert-danger">
                                <div *ngIf="addOxygenForm.controls['telnum'].errors.required">
                                    tel is required.
                              </div>
                            </div> -->
                          </div>
                      </div>
					  <div class="form-row">
						<div class="name"><i class="fa fa-lock" aria-hidden="true"></i> Mot de passe 
            </div>
						<div class="value">
							<div class="input-group">
								<input formControlName="password"  class="input--style-5" type="password" name="email">

							</div>
						  <!--   <div *ngIf="addOxygenForm.controls['telnum'].invalid && (addOxygenForm.controls['telnum'].dirty || addOxygenForm.controls['telnum'].touched)" class="alert alert-danger">
							  <div *ngIf="addOxygenForm.controls['telnum'].errors.required">
								  tel is required.
							</div>
						  </div> -->
						</div>
					</div>
				 
              
                        <div style="text-align: center;">
                           <button *ngIf="!showSpinner"  [disabled]="!addOxygenForm.valid" class="btn btn--radius-2 btn--red" type="submit">Se connecter</button>
                           <button  *ngIf="showSpinner" [disabled]="!addOxygenForm.valid" class="btn btn--radius-2 btn--red" type="submit">

                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Chargement en cours...
                          </button>
                      
                      
                           <!--  <button *ngIf="showSpinner" class="btn btn-primary" type="button" disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                              </button> --><br><br><hr>
                              <br>Vous n'avez pas un compte ? 
                                  <a class="txt2" routerLink="/signup" >
                                  S'inscrire
                                  <i class="fa fa-long-arrow-right m-l-5" aria-hidden="true"></i>
                                </a>
                                <br>Mot de passe oublié ? 
                                <a class="txt2" routerLink="/forgetpassword" >
                                  cliquer ici
                                <i class="fa fa-long-arrow-right m-l-5" aria-hidden="true"></i>
                              </a>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>

  
